module.exports = __webpack_public_path__ + "img/mini-bar.b56cf950.svg";